import _ from 'lodash';

export const createFontPickerWrapper = () => {
  const wrapperClassName = 'font-picker-wrapper';

  let fontPickerWrapper = _.first(document.getElementsByClassName(wrapperClassName));

  if (!fontPickerWrapper) {
    fontPickerWrapper = document.createElement('div');
    fontPickerWrapper.className = wrapperClassName;

    document.body.appendChild(fontPickerWrapper);
  }

  return fontPickerWrapper;
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/utils.js